// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"Featured_testimonial__L5Vi6","icon":"Featured_icon__9w7B8","position":"Featured_position__mNgyb"};